<script>
import { Line, mixins } from "vue-chartjs";
export default {
  extends: Line,
  data() {
    return {
      options: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              ticks: {
                fontSize: 14,
                fontFamily: "Prompt",
                fontStyle: "bold",
              },
            },
          ],
        },
        legend: {
          display: false,
        },
      },
    };
  },
  props: ["data"],
  watch: {
    data: function (newVal, oldVal) {
      this.renderChart(newVal, this.options);
    },
  },
  mounted() {
    this.renderChart(this.data, this.options);
  },
};
</script>

<style scoped></style>
